import { SET_SSO, CLEAR_SSO } from "../actions/ssoActions";

const initialState = {
  sso: "",
}

function ssoReducer(state = initialState, action) {
  switch (action.type) {
  case SET_SSO:
    return {
      ...state,
      sso: action.payload,
    }
  case CLEAR_SSO:
    return {
      ...state,
      sso: [],
    }
  default:
    return state;
  }
}

export default ssoReducer;